import Helpers from './Helpers';
import LoggedInUser from './LoggedInUser';

class Waitlist {
  static loadWaitlist(params){
    return fetch(Helpers.endpoint("/waitlist"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        offset: params.offset,
        limit: params.limit,
        buckets: params.buckets,
        assignees: params.assignees,
        completion: params.completion,
        profiles: params.profiles,
        search: params.search,
        auth_token: LoggedInUser.getInfo().auth_token
      })
    })
  }
}

export default Waitlist;
